import { isValid } from "./helper";

export const buildUrl = (
    baseUrl = '',
    options = {
        with: [],
        where: {}
    }
) => {
    let url = baseUrl
    let withUrlBit = ''
    let whereUrlBit = ''

    withUrlBit = options?.with ? options?.with.join(',') : '';

    // Gets only the _where_ keys whose values are valid (not null or undefined or empty)
    const whereKeys = options?.where ? Object.keys(Object.fromEntries(Object.entries(options.where).filter(([_, v]) => isValid(v)))) : [];
    for (let i = 0; i < whereKeys.length; i++) {
        const key = whereKeys[i];
        const value = options?.where[key];

        if(i === 0) {
            whereUrlBit = whereUrlBit.concat(`${key}=${value}`);
            continue;
        }

        if(whereKeys.length >= 1) {
            whereUrlBit = whereUrlBit.concat(`&${key}=${value}`);
        }
    }

    if(
        withUrlBit.length > 0
        && whereUrlBit.length > 0
    ) {
        url = url.concat(`?with=${withUrlBit}`, `&${whereUrlBit}`);
    } else if (withUrlBit.length > 0) {
        url = url.concat(`?with=${withUrlBit}`);
    } else if (whereUrlBit.length > 0) {
        url = url.concat(`?${whereUrlBit}`);
    }

    return url;
}
